module.exports = __webpack_public_path__ + "img/coupons_icon_expired_cn.8c878e3d.png";